const PUBLIC_URL = import.meta.env.BASE_URL.replace(/\/$/, "");

function getSettingsFromEnv() {
  const env: Record<string, string> = {};
  for (const [key, value] of Object.entries(import.meta.env)) {
    if (key.startsWith("VITE_") && typeof value === "string") {
      env[key] = value;
    }
  }
  return env;
}

const settings: Record<string, string> = getSettingsFromEnv();

export async function loadSettingOverrides() {
  const url = `${PUBLIC_URL}/settings.json`;
  const json = await fetch(url)
    .then((res) => res.json())
    .catch(() => ({}));
  Object.assign(settings, json);
}

export { settings };
